import { render } from "./around-section.vue?vue&type=template&id=46315c6c"
import script from "./around-section.vue?vue&type=script&lang=js"
export * from "./around-section.vue?vue&type=script&lang=js"

import "./around-section.vue?vue&type=style&index=0&id=46315c6c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__